module.exports = __webpack_public_path__ + "helvetica_neu_bold-webfont.df9c0bbf55d9844e6f9c.woff";


//////////////////
// WEBPACK FOOTER
// /var/lib/jenkins/workspace/landing_page/src/assets/fonts/helvetica_neu_bold-webfont.woff
// module id = ../../../../../src/assets/fonts/helvetica_neu_bold-webfont.woff
// module chunks = styles